"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _hoisted_1 = { id: "Results" };
const _hoisted_2 = { class: "CoverImage" };
const _hoisted_3 = ["srcset"];
const _hoisted_4 = ["srcset"];
const _hoisted_5 = ["srcset"];
const _hoisted_6 = ["srcset"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
    key: 0,
    class: "ResultsContainer"
};
const _hoisted_9 = { class: "row ResultRow" };
const _hoisted_10 = { class: "ResultHeader" };
const _hoisted_11 = { class: "ResultHeaderText" };
const _hoisted_12 = { class: "AccountName" };
const _hoisted_13 = { class: "Buttons" };
const _hoisted_14 = ["href", "title"];
const _hoisted_15 = ["href", "title"];
const _hoisted_16 = { class: "row OtherCountryRow" };
const _hoisted_17 = /*#__PURE__*/ (0, vue_1.createElementVNode)("h2", { class: "OtherHeader" }, " Other countries that fit you ", -1 /* HOISTED */);
const _hoisted_18 = { class: "CountryCards" };
const _hoisted_19 = ["href", "title"];
const _hoisted_20 = { class: "CountryCardName" };
const _hoisted_21 = ["href"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("picture", null, [
                (0, vue_1.createElementVNode)("source", {
                    media: "all and (max-width: 480px)",
                    srcset: `${_ctx.coverImageUrl}?h=200&w=480&fit=crop&auto=format`
                }, null, 8 /* PROPS */, _hoisted_3),
                (0, vue_1.createElementVNode)("source", {
                    media: "all and (min-width: 481px) and (max-width: 768px)",
                    srcset: `${_ctx.coverImageUrl}?h=200&w=768&fit=crop&auto=format`
                }, null, 8 /* PROPS */, _hoisted_4),
                (0, vue_1.createElementVNode)("source", {
                    media: "all and (min-width: 769px) and (max-width: 1024px)",
                    srcset: `${_ctx.coverImageUrl}?h=480&w=1024&fit=crop&auto=format`
                }, null, 8 /* PROPS */, _hoisted_5),
                (0, vue_1.createElementVNode)("source", {
                    media: "all and (min-width: 1025px)",
                    srcset: `${_ctx.coverImageUrl}?h=480&w=1920&fit=crop&auto=format`
                }, null, 8 /* PROPS */, _hoisted_6),
                (0, vue_1.createElementVNode)("img", {
                    src: `${_ctx.coverImageUrl}?h=480&w=1920&fit=crop&auto=format`
                }, null, 8 /* PROPS */, _hoisted_7)
            ])
        ]),
        (_ctx.firstResult)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [
                (0, vue_1.createElementVNode)("div", _hoisted_9, [
                    (0, vue_1.createElementVNode)("h2", _hoisted_10, [
                        (0, vue_1.createElementVNode)("i", {
                            class: (0, vue_1.normalizeClass)(`Icon flag-icon flag-icon-${_ctx.firstResult.iso.toLowerCase()}`)
                        }, null, 2 /* CLASS */),
                        (0, vue_1.createElementVNode)("span", _hoisted_11, [
                            (0, vue_1.createTextVNode)(" Congratulations "),
                            (0, vue_1.createElementVNode)("span", _hoisted_12, (0, vue_1.toDisplayString)(_ctx.userName), 1 /* TEXT */),
                            (0, vue_1.createTextVNode)(", your destination country is " + (0, vue_1.toDisplayString)(_ctx.firstResult.name) + "! ", 1 /* TEXT */)
                        ])
                    ]),
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.firstResult.description, (paragraph) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: paragraph,
                            class: "ResultText"
                        }, (0, vue_1.toDisplayString)(paragraph), 1 /* TEXT */));
                    }), 128 /* KEYED_FRAGMENT */)),
                    (0, vue_1.createElementVNode)("div", _hoisted_13, [
                        (0, vue_1.createElementVNode)("a", {
                            class: "Button DriverButton js-tracking-search",
                            href: `//${_ctx.searchURL}/${_ctx.firstResult.urlName}`,
                            title: `Explore studies in ${_ctx.firstResult.name}`,
                            target: "_blank"
                        }, " Explore studies in " + (0, vue_1.toDisplayString)(_ctx.firstResult.name), 9 /* TEXT, PROPS */, _hoisted_14),
                        (0, vue_1.createElementVNode)("a", {
                            class: "Button NavigatorButton js-tracking-country",
                            href: `//${_ctx.portalURL}/countries/${_ctx.firstResult.id}/`,
                            title: `Read more about ${_ctx.firstResult.name}`,
                            target: "_blank"
                        }, " Read more about " + (0, vue_1.toDisplayString)(_ctx.firstResult.name), 9 /* TEXT, PROPS */, _hoisted_15)
                    ])
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_16, [
                    _hoisted_17,
                    (0, vue_1.createElementVNode)("div", _hoisted_18, [
                        (_ctx.index !== 0)
                            ? ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, (0, vue_1.renderList)(_ctx.topResults, (result, index) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                    key: index,
                                    class: "CountryCard js-tracking-card",
                                    href: `//${_ctx.searchURL}/${result.urlName}`,
                                    title: `Explore studies in ${result.name}`,
                                    target: "_blank"
                                }, [
                                    (0, vue_1.createElementVNode)("i", {
                                        class: (0, vue_1.normalizeClass)(`Icon flag-icon flag-icon-${result.iso.toLowerCase()}`)
                                    }, null, 2 /* CLASS */),
                                    (0, vue_1.createElementVNode)("span", _hoisted_20, (0, vue_1.toDisplayString)(result.name), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_19));
                            }), 128 /* KEYED_FRAGMENT */))
                            : (0, vue_1.createCommentVNode)("v-if", true)
                    ]),
                    (0, vue_1.createElementVNode)("a", {
                        class: "HelperButton Dark js-tracking-explore",
                        href: `//${_ctx.portalURL}/countries/`,
                        title: "Explore all countries",
                        target: "_blank"
                    }, " Explore all countries ", 8 /* PROPS */, _hoisted_21)
                ])
            ]))
            : (0, vue_1.createCommentVNode)("v-if", true)
    ]));
}
exports.render = render;
